const CART_ADD_STOCK_URL = "/v1/cart/add";
const CART_SINGLE_LIST_URL = "/v1/cart/single";
const CART_STOCK_DELETE_URL = "/v1/cart/delete";
const CART_UPDATE_STOCK_URL = "/v1/cart/update";
const CART_CHANGE_PAYMENT_METHOD_URL = "/v1/cart/change-payment-method";

const CART_API_URL_LIST = {
    CART_ADD_STOCK_URL,
    CART_SINGLE_LIST_URL,
    CART_STOCK_DELETE_URL,
    CART_UPDATE_STOCK_URL,
    CART_CHANGE_PAYMENT_METHOD_URL
}

export { CART_API_URL_LIST };